import React from 'react';
import { styled, css } from 'styled-components';
import SvgClear from '../../../../play-core/icons/Clear';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { IconWrapper } from '../IconWrapper/IconWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Chip = ({
  title,
  showBorder = true,
  onClick,
  size = 'regular',
  showIcon = true,
  isDisabled = false
}) => /*#__PURE__*/_jsx(StyledChip, {
  showBorder: showBorder,
  size: size,
  isDisabled: isDisabled,
  onClick: onClick,
  children: /*#__PURE__*/_jsxs(ChipContent, {
    children: [/*#__PURE__*/_jsx(Title, {
      size: size,
      isDisabled: isDisabled,
      children: title
    }), showBorder && showIcon && /*#__PURE__*/_jsx(IconWrapper, {
      icon: /*#__PURE__*/_jsx(SvgClear, {}),
      color: Colors.GREY_d2d2d2,
      size: size === 'regular' ? 24 : 18
    })]
  })
});
const Title = styled.span.withConfig({
  displayName: "Chip__Title",
  componentId: "sc-14eb9yp-0"
})(["color:", ";", ""], ({
  isDisabled
}) => isDisabled ? Colors.GREY_969696 : Colors.GREY_d2d2d2, ({
  size
}) => size === 'regular' ? css(["", ";margin-left:7px;margin-right:10px;white-space:nowrap;"], Fonts.regular(16)) : css(["", ";margin:6px 8px 6px 5px;"], Fonts.regular(14)));
const ChipContent = styled.div.withConfig({
  displayName: "Chip__ChipContent",
  componentId: "sc-14eb9yp-1"
})(["display:flex;align-items:center;"]);
const StyledChip = styled.button.withConfig({
  displayName: "Chip__StyledChip",
  componentId: "sc-14eb9yp-2"
})(["background-color:", ";border:solid 1px ", ";border-color:", ";border-radius:24px;text-transform:initial;", " &:hover{background-color:", ";", "{color:", ";}}", ""], ({
  showBorder
}) => showBorder ? Colors.GREY_1a1a1a : Colors.GREY_2a2a2a, Colors.GREY_d2d2d2, ({
  showBorder,
  isDisabled
}) => isDisabled ? Colors.GREY_969696 : showBorder ? Colors.GREY_d2d2d2 : 'transparent', ({
  isDisabled
}) => isDisabled && css(["pointer-events:none;"]), ({
  showBorder
}) => showBorder ? Colors.GREY_2a2a2a : Colors.GREY_3a3a3a, Title, Colors.WHITE, ({
  size
}) => size === 'regular' ? css(["", ";height:35px;margin-right:12px;padding:0 8px;"], Fonts.regular(16)) : css(["", ";min-height:30px;margin-right:8px;padding:0 6px;"], Fonts.regular(14)));